import React from 'react'
import BaseTooth from './BaseTooth'
import { ToothComponentProps } from './types/tooth.types'

/** Factory for buccal-view tooth components (teeth 1–32). */
export const createToothBuccal = (
  toothNumber: number,
): React.FC<ToothComponentProps> => {
  const ToothComponent = (props: ToothComponentProps): React.ReactElement => {
    return <BaseTooth toothNumber={toothNumber} view="buccal" {...props} />
  }
  ToothComponent.displayName = `Tooth${toothNumber}`
  return ToothComponent
}
